// Sort order based on groups, and then race
const classificationSort = {
    "Women Owned": 1,
    "LGBTQ": 2,
    "Minority": 3,
    "Veteran Owned": 4,
    "Disability": 5,
    "Asian": 6,
    "Black Owned": 7,
    "Hispanic": 8,
    "Native American": 9,
    "Small Business": 10, 
};

/**
 * Helper function to determine which sticker image to show IF business applied for more than one
 * @param {array} classifications 
 */
export function getSortedDecalForDisplay(classifications) {
    return classifications.sort(function(classification1, classification2) {
        return classificationSort[classification1] - classificationSort[classification2];
    })
}